import { lazy, Suspense } from "react";
import { useAuth } from "../context/AuthContext";
import WodDisplay from "../components/WodDisplay";
import useScreenSize from "../context/ScreenContext";
import MainCard from "../components/Layouts/MainCard";
import { CardTitle } from "../components/theme/texts";
import { MainTitle, scrollBar, SpacedRow } from "../data/style/Style";

const Box = lazy(() => import("@mui/material/Box"));
const Stack = lazy(() => import("@mui/material/Stack"));
const Biometrics = lazy(() => import("../components/Biometrics"));
const NoDataDiv = lazy(() => import("../components/Display/NoDataDiv"));
const AthleteCard = lazy(() => import("../components/Display/AthleteCard"));
const WorkoutByTypePie = lazy(
  () => import("../components/charts/WorkoutByTypePie"),
);
const WorkoutByCategoryPie = lazy(
  () => import("../components/charts/WorkoutByCategoryPie"),
);

const Profile = () => {
  let { profile } = useAuth();
  const { size, mobileDevice } = useScreenSize();
  var [width] = size;

  return (
    <SpacedRow
      flexWrap={"wrap"}
      height={"100%"}
      sx={scrollBar}
      overflow={"auto"}
      rowGap={2}
    >
      <Stack flex={1} gap={2} minWidth={"270px"}>
        <SpacedRow flex={1} flexWrap={"wrap"} gap={2}>
          <Box flex={1} pr={2} minHeight={!mobileDevice && "260px"}>
            <MainCard>
              <CardTitle subTitle={"Info"} mainTitle={"Athlete"} />
              <AthleteCard />
            </MainCard>
          </Box>
          <Box flex={1} pr={2} minHeight={"260px"}>
            <MainCard>
              <CardTitle subTitle={"Biometrics"} mainTitle={"Weight Journey"} />
              <Biometrics />
            </MainCard>
          </Box>
        </SpacedRow>
        <Box flex={1} pr={2} pb={1}>
          <MainCard>
            <CardTitle subTitle={"Activity"} mainTitle={"Monthly Breakdown"} />
            <Stack direction={"row"} flexWrap={"wrap"}>
              <Suspense>
                <WorkoutByTypePie periodId={2} />
                <WorkoutByCategoryPie periodId={2} />
              </Suspense>
            </Stack>
          </MainCard>
        </Box>
      </Stack>
      <Stack
        height={"100%"}
        minWidth={"270px"}
        flex={mobileDevice || width < 750 ? 1 : 0.5}
        alignItems={width > 750 && "end"}
      >
        <Box pr={1} mb={2}>
          <MainTitle>Last 5 workouts</MainTitle>
        </Box>
        {profile.last_workouts.length > 0 ? (
          <Stack
            gap={2}
            overflow={"auto"}
            width={"95%"}
            sx={scrollBar}
            pr={1}
            pb={1}
          >
            {profile.last_workouts.map((item) => (
              <Box key={item.id} height={"60vh"}>
                <WodDisplay wodId={item.workout_id} />
              </Box>
            ))}
          </Stack>
        ) : (
          <Box height={"100%"} width={"100%"}>
            <NoDataDiv
              minHeight={"200px"}
              height={"100%"}
              text={"No data available."}
            />
          </Box>
        )}
      </Stack>
    </SpacedRow>
  );
};
export default Profile;
